/**
 * The admin shell (SPEC §9.1).
 *
 * Navigation only. Nothing here decides whether the caller is an
 * administrator: every `/api/admin/*` route is behind `require_admin`
 * server-side, and a non-admin who types the URL gets a 403 from the first
 * request the page makes. Hiding the tab is convenience, never protection.
 */

import { NavLink, Outlet } from 'react-router'

const TABS = [
  { to: '/admin/users', label: 'Users' },
  { to: '/admin/roles', label: 'Roles' },
  { to: '/admin/departments', label: 'Departments' },
  { to: '/admin/reports', label: 'Reports' },
  { to: '/admin/audit', label: 'Audit' },
  { to: '/admin/cache', label: 'Cache' },
] as const

export function AdminLayout() {
  return (
    <div className="space-y-4">
      <nav aria-label="Administration" className="border-b border-[var(--color-rule)]">
        <ul className="flex flex-wrap gap-1">
          {TABS.map((tab) => (
            <li key={tab.to}>
              <NavLink
                to={tab.to}
                className={({ isActive }) =>
                  `-mb-px inline-block border-b-2 px-3 py-2 text-[length:var(--text-sm)] ${
                    isActive
                      ? 'border-[var(--accent)] font-medium'
                      : 'border-transparent text-[var(--color-ink-muted)] hover:text-[var(--color-ink)]'
                  }`
                }
              >
                {tab.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <Outlet />
    </div>
  )
}
